import { AxiosResponse } from 'axios';
import { takeLatest, call, put, all, select } from 'redux-saga/effects';
import { KitItem } from '../../api/types';
import { SimplyTestApi } from '../../api/simplytest';
import { selectConfig } from '../../shared/redux/slice';
import { IConfiguration } from '../../shared/types';
import { selectIdToken, unauthorized } from '../../auth/redux/slice';
import clinicSubmissionSlice, { loadAvailableKits } from './slice';

export abstract class ClinicSubmissionSagas {
    public static* run(){
        try {
            yield all([
                takeLatest(loadAvailableKits, ClinicSubmissionSagas.loadAvailableKits),
            ]);
        }
        catch(e: any){
            console.log(`[ClinicSubmissionSagas:run] the following exception has occurred`, e);
        }
    }

    private static* loadAvailableKits(action: ReturnType<typeof loadAvailableKits>){
        try {
            yield put(clinicSubmissionSlice.actions.setAvailableKitsLoading(true));

            const config: IConfiguration = yield select(selectConfig);
            const idToken: string = yield select(selectIdToken);

            var client = new SimplyTestApi(config.apiBaseUrl, idToken);
            const response: AxiosResponse<KitItem[]> = yield call(
                { context: client, fn: client.getAvailableKits },
                action.payload,
            );

            if(response.status === 401)
            {
                yield put(unauthorized(undefined));
                return;
            }

            if(response.status !== 200) {
                yield put(clinicSubmissionSlice.actions.setAvailableKitsLoading(false));
                return;
            }

            yield put(clinicSubmissionSlice.actions.setAvailableKits(response.data));
        }
        catch(e: any){
            console.log(`[ClinicSubmissionSagas:loadAvailableKits] the following exception has occurred`, e);
            yield put(clinicSubmissionSlice.actions.setAvailableKitsLoading(false));
        }
    }
}
